/**
 * Adds the value to the array, if it's not in the array, otherwise removes the value.
 *
 * @export
 * @param {Array} array The array to modify.
 * @param {any} value The value to insert or remove.
 * @returns The resulting array.
 */
export function toggle (array, value) {
  if (!array || !value) {
    return undefined
  }

  if (!Array.isArray(array)) {
    return undefined
  }

  const indexOfNewValue = array.indexOf(value)

  if (indexOfNewValue >= 0) {
    array.splice(indexOfNewValue, 1)
  } else {
    array = array.concat(value)
  }

  return array
}

/**
 * Sorts the array by comparing the appropriate key.
 *
 * @export
 * @param {Array} array The array to sort.
 * @param {string} key The name of the property to sort by.
 */
export function sortByKey (array, key) {
  const sorted = array.sort((a, b) => {
    if (a[key] > b[key]) {
      return -1
    } else if (a[key] < b[key]) {
      return 1
    }
    return 0
  })
  return sorted
}
